var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.componentClass, style: _vm.componentStyle },
    [
      _vm.hasIcon
        ? _c("font-awesome-icon", {
            staticClass: "decorative",
            attrs: {
              icon: _vm.$v6[_vm.iconStyle][_vm.iconName],
              rotation: _vm.iconRotation,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("title", function () {
        return [
          _vm.hasTitle
            ? _c("h4", { staticClass: "h5" }, [
                _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
              ])
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm._t("content", function () {
        return [
          _vm.hasContent
            ? _c("p", { staticStyle: { "--paragraph-margin-bottom": "0" } }, [
                _vm._v("\n      " + _vm._s(_vm.content) + "\n    "),
              ])
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          staticStyle: {
            "--with-close-close-font-size": "var(--font-size-md)",
            top: "1rem",
            right: "1rem",
          },
          attrs: {
            type: "button",
            "aria-label": _vm.ariaLabelClose,
            "data-balloon-pos": "up-right",
          },
          on: { click: _vm.dismissNudge },
        },
        [_c("font-awesome-icon", { attrs: { icon: _vm.$v6.solid.faXmark } })],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }